/*@ngInject*/
const UIScrollToItemDirective = function ($timeout, coreConstant) {

    let linkFunction = function ($scope, $elm, $attrs) {
        let element = $($elm);

        $scope.$on(coreConstant.event.SCROLL_TO_ITEM, function (event, itemId) {
            scrollToItem(itemId);
        });

        function scrollToItem(itemId) {
            $timeout(function () {
                let itemElement = $('.item-id-' + itemId);

                element.animate({
                    scrollTop: itemElement.offset().top - element.offset().top + element.scrollTop()
                }, 300);
            }, 100);
        }
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiScrollToItem', UIScrollToItemDirective);
